import { api } from './client.js'

let cached = null

export function loadLimits({ get = url => api.get(url).then(r => r.data) } = {}) {
  if (!cached)
    cached = get('/api/files/limits').catch(e => {
      cached = null
      throw e
    })
  return cached
}

export const resetLimits = () => {
  cached = null
}
